// extracted by mini-css-extract-plugin
export var label = "_dv-2";
export var slideContainer = "_dv-0";
export var slider = "_dv-1";